import request from "@/utils/request";

export function reqSummary(data) {
  return request({
    url: "salesSummary/getSummary",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
    },
  })
};

export function reqEmployeeSales(data) {
  return request({
    url: "salesSummary/getEmployeeSales",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
      pageNum: data.pageNum,
      pageSize: data.pageSize,
    },
  })
};

export function reqProductSales(data) {
  return request({
    url: "salesSummary/getProductSales",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
      sortType: data.sortType,
      productValue: data.productValue,
      filterData: data.filterdata,
      pageNum: data.pageNum,
      pageSize: data.pageSize,
    },
  })
};

export function reqDimensions() {
  return request({
    url: "salesSummary/getDimensions",
    method: "post",
  })
};

export function reqDailySummary(data) {
  return request({
    url: "salesSummary/getDailySummary",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
    },
  })
};

export function reqHourlySummary(data) {
  return request({
    url: "salesSummary/getHourlySummary",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
    },
  })
};

export function reqProductDailySales(data) {
  return request({
    url: "salesSummary/getProductDailySales",
    method: "post",
    params: {
      startDate: data.startDate,
      endDate: data.endDate,
      productCode: data.productCode,
    },
  })
};




// WEBPACK FOOTER //
// ./src/api/board.js